export default "__VITE_ASSET__CBW66zRd__"